// utils.js
export function trimStringValues(obj: any) {
    for (const key in obj) {
        if (typeof obj[String(key)] === 'string') {
            obj[String(key)] = obj[String(key)].trim()
        }
    }
    return obj
}
